"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var lodash_1 = __importDefault(require("lodash"));
var searchParamsSlice_1 = require("../../../../features/searchParams/searchParamsSlice");
var filters_1 = require("../../../../helpers/filters");
var TableRow_1 = __importDefault(require("./TableRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SavedSearchTable = function (_a) {
    var savedSearches = _a.savedSearches, onRemove = _a.onRemove;
    var t = react_i18next_1.useTranslation('common').t;
    var allFilters = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var formSummary = function (filters) {
        if (!filters || !allFilters) {
            return [];
        }
        return lodash_1.default.reduce(allFilters, function (acc, f, k) {
            var filterValue = filters[k];
            if (!filters[k] || k === 'district') {
                return acc;
            }
            if (lodash_1.default.isArray(filterValue)) {
                filterValue.forEach(function (val) {
                    if (k === 'state') {
                        var state = f.options.find(function (s) { return s.govId === val; });
                        if (state) {
                            acc.push(state.text);
                        }
                        return;
                    }
                    var option = f.options.find(function (f) { return f.val === val; });
                    if (option) {
                        acc.push(t("FILTER." + k.toUpperCase()).toUpperCase() +
                            ': ' +
                            t("FIELD_OPTIONS." + option.val, option.text));
                    }
                });
            }
            if (lodash_1.default.isString(filterValue)) {
                acc.push(t("FILTER." + k.toUpperCase()).toUpperCase() +
                    ': ' +
                    t("FIELD_OPTIONS." + filterValue, filterValue));
            }
            return acc;
        }, []);
    };
    var history = react_router_dom_1.useHistory();
    var navigateToSearch = function (id) {
        var data = savedSearches[id];
        var queryUrl = filters_1.createQueryUrl(__assign(__assign({}, data.params), { customViewBox: data.params.customViewBox
                ? data.params.customViewBox[0]
                : [] }));
        history.push("/" + data.params.deal + "?" + queryUrl);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.saved_search_table },
        react_1.default.createElement(semantic_ui_react_1.Table, null,
            react_1.default.createElement(semantic_ui_react_1.Table.Header, { className: styles_module_scss_1.default.header },
                react_1.default.createElement(semantic_ui_react_1.Table.Row, null,
                    react_1.default.createElement(semantic_ui_react_1.Table.HeaderCell, { className: styles_module_scss_1.default.saved_search_name }, t('Account.SAVED_SEARCH.NAME')),
                    react_1.default.createElement(semantic_ui_react_1.Table.HeaderCell, null, t('Account.SAVED_SEARCH.FILTERS')),
                    react_1.default.createElement(semantic_ui_react_1.Table.HeaderCell, null, t('Account.SAVED_SEARCH.ACTIONS')))),
            react_1.default.createElement(semantic_ui_react_1.Table.Body, { className: styles_module_scss_1.default.body }, savedSearches.map(function (data, index) {
                var params = data.params;
                var filtersSummary = formSummary(params);
                return (react_1.default.createElement(TableRow_1.default, { navigateToSearch: navigateToSearch, key: index, index: index, filters: filtersSummary, onRemove: onRemove }));
            })))));
};
exports.default = SavedSearchTable;
